import React from 'react';
import { connect } from 'react-redux';
import {
  activateModal,
  activateMeasure,
  deactivateMeasure,
  resetMap,
  restorePredefinedMapLayers,
} from '../../store/actions';

import MapToolbar from './MapToolbar';

export function MapToolbarWrapperComponent(props) {
  return (
    <MapToolbar {...props} />
  );
}

/* istanbul ignore next */
export const mapStateToProps = (state, { type }) => {
  return {
    demographics: state[type].mapLayers.get('demographics'),
    backgroundColor: state.viewer.backgroundColor,
    measure: state.measure,
    zoom: state.viewportInfo.zoom,
    predefinedLayers: state[type].mapLayers.get('predefinedLayer'),
    businesses: ((state[type] || {}).businesses || {}).items,
    customLayers: state[type].mapLayers.get('customLayer'),
    mapLoading: state.mapLoading,
    layers: state.viewer.layers ? (state.viewer.layers.custom || []) : [],
    layersActive: () => {
      const { viewer: { layers = {} } } = state;
      const predefinedLayers = state[type].mapLayers.get('predefinedLayer');
      const customLayers = state[type].mapLayers.get('customLayer');
      const businesses = ((state[type] || {}).businesses || {}).items;
      const demographics = state[type].mapLayers.get('demographics');
      const filtersEmpty = (state[type].filters || new Map()).size;
      const filterDrawnLayer = state[type].filterDrawnLayer;
      const fdlEmpty = !(Object.keys(filterDrawnLayer || {}).length === 0
        && (filterDrawnLayer && filterDrawnLayer.constructor === Object));
      // check predefinedLayers for defaults
      const isLayerActiveByDefault = layer => {
        const key = layer.replace(' ', '').toLowerCase();
        return layers.default && layers.default[key] === 2;
      };
      return (predefinedLayers && predefinedLayers.some(pl => !isLayerActiveByDefault(pl)))
        || (customLayers && customLayers.length)
        || businesses || demographics || state.measure
        || filtersEmpty || fdlEmpty;
    },
  };
};

/* istanbul ignore next */
export const mapDispatchToProps = dispatch => {
  return {
    showShareModal: () => { dispatch(activateModal('share-map')); },
    activateMeasure: () => { dispatch(activateMeasure()); },
    deactivateMeasure: () => { dispatch(deactivateMeasure()); },
    resetPredefinedLayers: type => { dispatch(restorePredefinedMapLayers(type)); },
    resetMap: (layersActive, type) => {
      dispatch(resetMap(layersActive, type));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapToolbarWrapperComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/MapToolbarWrapper.js